<template>
    <div class="conter">
        <div class="currency_suggest">
            <div class="titel" v-if="reporInfo.third_img != null">
                <span>三维施工图</span>
            </div>
            <div v-if="reporInfo.third_img != null" class="tips_img" @click="goSanwei(reporInfo.third_img)">
                <img :src="reporInfo.third_img_url" alt="" />
            </div>
            <div class="titel">
                <span>系统设计图</span>
            </div>
            <div class="deploy-banner">
                <swiper class="slide" :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(switem, swindex) in reporInfo.goods_album" :key="swindex" class="slide-list">
                        <div class="drang-lab" v-if="switem.imgname != ''">
                            {{ switem.imgname }}
                        </div>
                        <img :src="switem.img" alt="" preview="1"/>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <!-- 系统报价 -->
        <!-- 暂时废弃  reporInfo.show_amount != 0 !objOffer.arrInfo.length展示 -->
        <div class="currency_suggest" v-if="!objOffer.arrInfo.length">
            <div class="titel">
                <span>项目配置清单</span>
            </div>
            <!-- 套餐报价 reporInfo.show_amount == 2-->
            <div class="piceTaocan">
                <div class="conter_pice">
                    <div class="setmeal_shopp" v-for="(item, index) in reporInfo.product" :key="index" @click="getDetails(item.product_id)" v-show="reporInfo.product.length">
                        <div class="setmeal_shopp_list">
                            <div class="shopp_item shopp_two">
                                <img class="" v-lazy="item.mobile_img" alt="" />
                            </div>
                            <div class="shopp_item shopp_three">
                                <div class="type_name">
                                    {{ item.new_goods_type_name }}
                                </div>
                                <div>
                                    {{ item.goods_name }}
                                </div>
                                <div class="attr_label" v-for="(sumitem, sumindex) in item.attr_two" :key="sumindex">
                                    <div>{{ sumitem.attr_name }}</div>
                                    :
                                    <div>{{ sumitem.attr_value }}</div>
                                </div>
                            </div>
                            <div class="shopp_item shopp_four">
                                {{ item.num }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="money" v-if="reporInfo.show_amount != 0">
                    套餐价格：￥{{ reporInfo.report_amount }}
                </div>
            </div>
        </div>
        <!-- objOffer.arrInfo.length -->
        <div class="currency_suggest" v-if="objOffer.arrInfo.length">
            <div class="titel">
                <span>项目配置清单</span>
            </div>
            <div class="list_item" v-for="(item, index) in objOffer.arrInfo" :key="index">
                <div v-show="item.goods.length">
                    <div class="list_header">
                        <div class="min_title">
                            {{
                                "Step" +
                                (index + 1) +
                                ":" +
                                item.info.type_group_name
                            }}
                        </div>
                    </div>
                    <div class="tabel_title">
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:40%;'
                                    : ''
                            ">
                            名称
                        </div>
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:40%;'
                                    : ''
                            ">
                            规格型号
                        </div>
                        <div class="tabel_title_item" v-if="objOffer.order.show_amount != 0">
                            单价
                        </div>
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:20%;'
                                    : ''
                            ">
                            数量
                        </div>
                    </div>
                    <div class="tabel_content">
                        <div class="tabel_content_list" v-for="(sumitem, sumindex) in item.goods" :key="sumindex">
                            <div class="tabel_content_item" :style="
                                    objOffer.order.show_amount == 0
                                        ? 'width:40%;'
                                        : ''
                                ">
                                {{ sumitem.name }}
                            </div>
                            <div class="tabel_content_item" :style="
                                    objOffer.order.show_amount == 0
                                        ? 'width:40%;'
                                        : ''
                                ">
                                {{ sumitem.code }}
                            </div>
                            <div class="tabel_content_item" v-if="objOffer.order.show_amount != 0">
                                <div class="tabel_input" :style="
                                        objOffer.order.show_amount == 0
                                            ? 'width:20%;'
                                            : ''
                                    ">
                                    {{ sumitem.amount }}
                                </div>
                            </div>
                            <div class="tabel_content_item">
                                <div class="tabel_input">{{ sumitem.num }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="subtotal" v-if="objOffer.order.show_amount != 0">
                        <div>小计:</div>
                        <div>
                            {{
                                Number(item.info.total_amount).toFixed(2) + "元"
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="total" v-if="objOffer.order.show_amount != 0">
                <div>总计:</div>
                <div>
                    {{ Number(objOffer.order.order_amount).toFixed(2) + "元" }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        objOffer: {
            type: Object,
            default: function () {
                return {};
            },
        },
        nCuiltips: {
            type: Number,
            default: function () {
                return 0;
            },
        },
        arrVrList: {
            type: Array,
            default: false,
        },
        reporInfo: {
            type: Object,
            default: false,
        },
    },
    data() {
        const vm = this;
        return {
            showSwiper: false,
            arrErnav: [{ title: "系统报价" }, { title: "套餐报价" }],
            arrClass: [
                { leftClass: "letfone" },
                // { leftClass: "letftwo" },
                { leftClass: "letfthree" },
                // { leftClass: "letffour" },
            ],
            arrTabelNav: [
                { room_type: "项目" },
                { room_type: "型号/规格" },
                { room_type: "单价" },
                { room_type: "数量" },
            ],
            secondIndex: 0,
            nducat: 0,
            //当滚到一定距离开启动画
            bSubtop: false,
            //系统对比提示框
            bLaber: false,
            //轮播图配置
            swiperOption: {
                speed: 200,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                on: {
                    slideChangeTransitionEnd() {
                        vm.headIndex = this.activeIndex;
                    },
                },
            },
            swiperOptiontwo: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swiper) {
                        // this.swiperIndex = this.swiper.activeIndex;
                    }.bind(this),
                },
            },
            swiperOptionvr: {
                speed: 200,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    // clickable: true, // 允许点击小圆点跳转
                },
                on: {
                    slideChangeTransitionEnd() {
                        vm.headIndex = this.activeIndex;
                    },
                },
            },
        };
    },
    filters: {
        roomNumber(index) {
            let arr = [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
            ];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
    },
    computed: {
        // 轮播实例对象
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
        swipervr() {
            return this.$refs.mySwipervr.swiper;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.windowScroll); //监听页面滚动
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
    },
    methods: {
        //查看商品详情
        getDetails(id) {
            this.$router.push({ path: `/shopp/details?id=${id}` });
        },
        //查看图片
        //图片查看器
        lookImg(index) {
            this.showSwiper = true;
            this.swiper.slideTo(index, 1000, true);
        },
        goSanwei(url) {
            window.location.href = url;
        },
        //点击二级导航
        getAtcStr(index) {
            this.secondIndex = index;
        },
        goVr(item) {
            window.location.href = item;
        },
        //页面滚动,导航切换显示
        windowScroll() {
            this.getTopAnmin();
        },
        //点击功能对比选项卡
        getEducation(index) {
            if (index == 2) {
                this.nCuiltips = 0;
                this.nCuilId = 1;
            } else {
            }
            this.nducat = index;
            this.bSubtop = false;
            this.bLaber = false;
            setTimeout(() => {
                this.getTopAnmin();
            }, 300);
        },
        //监听元素与顶部的距离，开启动画
        getTopAnmin() {
            let subTop = this.$refs.contrast.getBoundingClientRect().top;
            if (subTop < 200) {
                if (this.nducat == 2 || this.nducat == 1 || this.nducat == 0) {
                    this.bSubtop = true;
                }
            } else {
                this.bSubtop = false;
            }
        },
        //点击系统对比选项卡
        getTips(index, id, nducatIndex) {
            this.bSubtop = false;
            this.nCuilId = id;
            this.nCuiltips = index;
            setTimeout(() => {
                this.getTopAnmin();
            }, 200);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>